var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.active}},[_c('div',{staticClass:"close"},[_c('img',{attrs:{"src":require("../../../assets/label-close.png")},on:{"click":function($event){$event.stopPropagation();return _vm.close($event)}}})]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-051c7868","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/PageTagList/page-put-tag.vue
// module id = null
// module chunks = 